<template>
  <section class="dte-standard-box">
    <table class="dte-standard-table dte-standard-table--boxed">
      <tbody>
        <tr class="dte-standard-table__title-row" :style="titleRowStyle">
          <td :colspan="headers.length" class="dte-standard-table__title-cell">
            {{ title }}
          </td>
        </tr>
        <tr class="dte-standard-table__header-row">
          <th
            v-for="header in headers"
            :key="header"
            class="dte-standard-table__header-cell"
          >
            {{ header }}
          </th>
        </tr>
        <tr
          v-for="(row, rowIndex) in rows"
          :key="`row-${rowIndex}`"
        >
          <td
            v-for="(value, cellIndex) in row"
            :key="`cell-${rowIndex}-${cellIndex}`"
            class="dte-standard-table__body-cell"
          >
            {{ value }}
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { getStandardThemeColors } from "../utils/dtePrintStandard";

export default {
  name: "DteStandardDataTableSection",
  props: {
    documentData: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    titleRowStyle() {
      const colors = getStandardThemeColors(this.documentData);
      return {
        backgroundColor: colors.bg,
        color: colors.fg,
      };
    },
  },
};
</script>
